/**
 * Profile validation schemas (Zod v4).
 */
import { z } from 'zod'
import { sanitizeName } from '../utils/sanitize'
import { AGE_REQUIREMENTS } from '../utils/constants'
import { yearsBetween } from '../utils/dates'

export const updateProfileSchema = z.object({
  firstName: z
    .string()
    .min(2, 'auth.validation.first_name_min')
    .max(50, 'auth.validation.first_name_max')
    .transform(sanitizeName)
    .optional(),
  lastName: z
    .string()
    .min(2, 'auth.validation.last_name_min')
    .max(50, 'auth.validation.last_name_max')
    .transform(sanitizeName)
    .optional(),
  dateOfBirth: z
    .string()
    .refine((v) => {
      const dob = new Date(v + 'T00:00:00')
      return yearsBetween(dob, new Date()) >= AGE_REQUIREMENTS.minimumBooking
    }, 'profile.validation.min_age')
    .optional(),
  preferredLocale: z.enum(['es', 'en']).optional(),
  preferredCurrency: z.enum(['USD']).optional(),
  // City + country IDs reference the catalog tables — no shape validation
  // beyond "non-empty string". Picker UIs only emit valid IDs from a
  // useCities() / useCountries() result, so freeform validation here
  // would be redundant. cityId can imply countryId (we co-set both).
  cityId: z.string().min(1).optional(),
  countryId: z.string().min(1).optional(),
})

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>
